// BARRA DE AVISOS: PARCHE DEL SLIDESHOW DE DAWN (06-10-2026, revision de Clarity).
// Desde el 01-10 la barra lleva 4 avisos en autoplay y Clarity registra
// «currentSlide.classList» (Safari: undefined is not an object). Si el slider se mide
// con ancho 0 (seccion oculta al montarse, pestaña en segundo plano, bfcache),
// `sliderItemOffset` queda undefined, `currentPage` sale NaN y
// `applyAnimationToAnnouncementBar` lee `sliderItems[NaN]`. Este fichero carga con defer
// DESPUES de global.js en todas las paginas, asi que aqui se envuelve el metodo:
// se re-mide y, si sigue sin indice valido, se salta la animacion en vez de romper.
(function () {
  var Slideshow = window.customElements && customElements.get('slideshow-component');
  if (!Slideshow) return;
  var original = Slideshow.prototype.applyAnimationToAnnouncementBar;
  Slideshow.prototype.applyAnimationToAnnouncementBar = function (button) {
    if (!this.announcementBarSlider) return;
    var count = this.sliderItems ? this.sliderItems.length : 0;
    var valid = function (page) {
      return Number.isInteger(page) && page >= 1 && page <= count;
    };
    if (!valid(this.currentPage)) {
      this.initPages();
      if (!valid(this.currentPage)) return;
    }
    return original.call(this, button);
  };
})();

document.addEventListener('DOMContentLoaded', function () {
  // SIN BARAJAR (24-09-2026, orden de Jaime: «que se vaya mostrando lo ultimo subido en orden
  // en todo»). Antes este fichero barajaba los sliders (NEW ARRIVALS) en cada visita y las
  // parrillas de coleccion una vez por sesion. Ahora se respeta el orden que manda Shopify
  // (todas las colecciones en CREATED_DESC): de lo ultimo subido a lo mas viejo. En las
  // parrillas solo se mandan las agotadas al final, sin cambiar el orden dentro de cada grupo.

  function isSoldOut(item) {
    const el = item.querySelector('[data-sold-out]');
    return el ? el.getAttribute('data-sold-out') === 'true' : false;
  }

  function setupAutoplay(grid, sliderComponent) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    // Continuous per-frame motion fights CSS scroll-snap (each frame nudge gets
    // treated as a new scroll gesture the browser tries to re-snap), so autoplay
    // drives the slider without snap. Manual drag/swipe still works, just unsnapped.
    grid.style.scrollSnapType = 'none';
    grid.style.scrollBehavior = 'auto';

    const SPEED_PX_PER_SEC = 28;
    const RESUME_DELAY = 1500;
    let direction = 1;
    let lastTime = null;
    let paused = false;
    let resumeTimer = null;
    // INP (06-10-2026): cada frame que escribe scrollLeft dispara el `update()` de Dawn, que
    // lee offsetLeft/clientWidth (layout forzado). Antes el bucle corria SIEMPRE, tambien con
    // el slider fuera de pantalla o la pestaña oculta, y competia con cada toque de la home.
    // Ahora solo corre si el slider se ve y la pestaña esta visible.
    let onScreen = false;
    let frame = null;
    // scrollLeft only stores integers, so re-reading it each frame truncates
    // the sub-pixel delta to 0 and the slider never moves. Track position as
    // a float ourselves and only push the rounded value into scrollLeft.
    let position = grid.scrollLeft;

    function shouldRun() {
      return onScreen && !paused && !document.hidden;
    }

    function tick(time) {
      frame = null;
      if (!shouldRun()) return;
      if (lastTime === null) lastTime = time;
      const delta = Math.min((time - lastTime) / 1000, 0.1);
      lastTime = time;

      const maxScroll = grid.scrollWidth - grid.clientWidth;
      position += direction * SPEED_PX_PER_SEC * delta;

      if (position >= maxScroll) {
        position = maxScroll;
        direction = -1;
      } else if (position <= 0) {
        position = 0;
        direction = 1;
      }

      grid.scrollLeft = position;
      frame = requestAnimationFrame(tick);
    }

    function start() {
      if (frame !== null || !shouldRun()) return;
      lastTime = null;
      position = grid.scrollLeft;
      frame = requestAnimationFrame(tick);
    }

    function pause() {
      paused = true;
    }

    function resume() {
      paused = false;
      start();
    }

    function pauseThenResume() {
      pause();
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(resume, RESUME_DELAY);
    }

    grid.addEventListener('mouseenter', pause);
    grid.addEventListener('mouseleave', resume);
    grid.addEventListener('touchstart', pauseThenResume, { passive: true });
    grid.addEventListener('pointerdown', pauseThenResume);
    document.addEventListener('visibilitychange', start);

    const sliderButtons = sliderComponent ? sliderComponent.querySelectorAll('.slider-button') : [];
    sliderButtons.forEach(function (button) {
      button.addEventListener('click', pauseThenResume);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        start();
      }).observe(grid);
    } else {
      onScreen = true;
      start();
    }
  }

  document.querySelectorAll('.product-grid').forEach(function (grid) {
    if (grid.classList.contains('slider')) {
      setupAutoplay(grid, grid.closest('slider-component'));
      return;
    }
    const items = Array.from(grid.children);
    const available = items.filter(function (item) {
      return !isSoldOut(item);
    });
    const soldOut = items.filter(isSoldOut);
    available.concat(soldOut).forEach(function (item) {
      grid.appendChild(item);
    });
  });
});
